/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CustomResult } from '../models/custom-result';
import { CustomResultOfAuditVm } from '../models/custom-result-of-audit-vm';
import { CustomResultOfByteOf } from '../models/custom-result-of-byte-of';
import { CustomResultOfListOfSocialMediaMessageFilesForSendDto } from '../models/custom-result-of-list-of-social-media-message-files-for-send-dto';
import { CustomResultOfPaginatedListOfSocialMediaMessageFilesWithPaginationDto } from '../models/custom-result-of-paginated-list-of-social-media-message-files-with-pagination-dto';
import { CustomResultOfString } from '../models/custom-result-of-string';
import { socialNetworkMessageFilesCreateGet } from '../fn/social-network-message-files/social-network-message-files-create-get';
import { SocialNetworkMessageFilesCreateGet$Params } from '../fn/social-network-message-files/social-network-message-files-create-get';
import { socialNetworkMessageFilesCreatePost } from '../fn/social-network-message-files/social-network-message-files-create-post';
import { SocialNetworkMessageFilesCreatePost$Params } from '../fn/social-network-message-files/social-network-message-files-create-post';
import { socialNetworkMessageFilesDelete } from '../fn/social-network-message-files/social-network-message-files-delete';
import { SocialNetworkMessageFilesDelete$Params } from '../fn/social-network-message-files/social-network-message-files-delete';
import { socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray } from '../fn/social-network-message-files/social-network-message-files-download-social-media-file-as-byte-array';
import { SocialNetworkMessageFilesDownloadSocialMediaFileAsByteArray$Params } from '../fn/social-network-message-files/social-network-message-files-download-social-media-file-as-byte-array';
import { socialNetworkMessageFilesDownloadSocialMediaMessageFileById } from '../fn/social-network-message-files/social-network-message-files-download-social-media-message-file-by-id';
import { SocialNetworkMessageFilesDownloadSocialMediaMessageFileById$Params } from '../fn/social-network-message-files/social-network-message-files-download-social-media-message-file-by-id';
import { socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination } from '../fn/social-network-message-files/social-network-message-files-get-social-media-message-files-audit-with-pagination';
import { SocialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination$Params } from '../fn/social-network-message-files/social-network-message-files-get-social-media-message-files-audit-with-pagination';
import { socialNetworkMessageFilesGetSocialMediaMessageFilesForSend } from '../fn/social-network-message-files/social-network-message-files-get-social-media-message-files-for-send';
import { SocialNetworkMessageFilesGetSocialMediaMessageFilesForSend$Params } from '../fn/social-network-message-files/social-network-message-files-get-social-media-message-files-for-send';
import { socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination } from '../fn/social-network-message-files/social-network-message-files-get-social-media-message-files-with-pagination';
import { SocialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination$Params } from '../fn/social-network-message-files/social-network-message-files-get-social-media-message-files-with-pagination';
import { socialNetworkMessageFilesUpdateStatus } from '../fn/social-network-message-files/social-network-message-files-update-status';
import { SocialNetworkMessageFilesUpdateStatus$Params } from '../fn/social-network-message-files/social-network-message-files-update-status';

@Injectable({ providedIn: 'root' })
export class SocialNetworkMessageFilesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `socialNetworkMessageFilesCreateGet()` */
  static readonly SocialNetworkMessageFilesCreateGetPath = '/SocialNetworkMessageFiles/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesCreateGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesCreateGet$Response(params?: SocialNetworkMessageFilesCreateGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return socialNetworkMessageFilesCreateGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesCreateGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesCreateGet(params?: SocialNetworkMessageFilesCreateGet$Params, context?: HttpContext): Observable<Blob> {
    return this.socialNetworkMessageFilesCreateGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesCreatePost()` */
  static readonly SocialNetworkMessageFilesCreatePostPath = '/SocialNetworkMessageFiles/Create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesCreatePost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  socialNetworkMessageFilesCreatePost$Response(params?: SocialNetworkMessageFilesCreatePost$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return socialNetworkMessageFilesCreatePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesCreatePost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  socialNetworkMessageFilesCreatePost(params?: SocialNetworkMessageFilesCreatePost$Params, context?: HttpContext): Observable<CustomResult> {
    return this.socialNetworkMessageFilesCreatePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesUpdateStatus()` */
  static readonly SocialNetworkMessageFilesUpdateStatusPath = '/SocialNetworkMessageFiles/UpdateStatus';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesUpdateStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesUpdateStatus$Response(params: SocialNetworkMessageFilesUpdateStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return socialNetworkMessageFilesUpdateStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesUpdateStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesUpdateStatus(params: SocialNetworkMessageFilesUpdateStatus$Params, context?: HttpContext): Observable<CustomResult> {
    return this.socialNetworkMessageFilesUpdateStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesDelete()` */
  static readonly SocialNetworkMessageFilesDeletePath = '/SocialNetworkMessageFiles/Delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesDelete$Response(params: SocialNetworkMessageFilesDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResult>> {
    return socialNetworkMessageFilesDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesDelete(params: SocialNetworkMessageFilesDelete$Params, context?: HttpContext): Observable<CustomResult> {
    return this.socialNetworkMessageFilesDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResult>): CustomResult => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination()` */
  static readonly SocialNetworkMessageFilesGetSocialMediaMessageFilesWithPaginationPath = '/SocialNetworkMessageFiles/GetSocialMediaMessageFilesWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination$Response(params: SocialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfPaginatedListOfSocialMediaMessageFilesWithPaginationDto>> {
    return socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination(params: SocialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination$Params, context?: HttpContext): Observable<CustomResultOfPaginatedListOfSocialMediaMessageFilesWithPaginationDto> {
    return this.socialNetworkMessageFilesGetSocialMediaMessageFilesWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfPaginatedListOfSocialMediaMessageFilesWithPaginationDto>): CustomResultOfPaginatedListOfSocialMediaMessageFilesWithPaginationDto => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination()` */
  static readonly SocialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPaginationPath = '/SocialNetworkMessageFiles/GetSocialMediaMessageFilesAuditWithPagination';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination$Response(params: SocialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfAuditVm>> {
    return socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination(params: SocialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination$Params, context?: HttpContext): Observable<CustomResultOfAuditVm> {
    return this.socialNetworkMessageFilesGetSocialMediaMessageFilesAuditWithPagination$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfAuditVm>): CustomResultOfAuditVm => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesGetSocialMediaMessageFilesForSend()` */
  static readonly SocialNetworkMessageFilesGetSocialMediaMessageFilesForSendPath = '/SocialNetworkMessageFiles/GetSocialMediaMessageFilesForSend';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesGetSocialMediaMessageFilesForSend()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesGetSocialMediaMessageFilesForSend$Response(params?: SocialNetworkMessageFilesGetSocialMediaMessageFilesForSend$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfListOfSocialMediaMessageFilesForSendDto>> {
    return socialNetworkMessageFilesGetSocialMediaMessageFilesForSend(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesGetSocialMediaMessageFilesForSend$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesGetSocialMediaMessageFilesForSend(params?: SocialNetworkMessageFilesGetSocialMediaMessageFilesForSend$Params, context?: HttpContext): Observable<CustomResultOfListOfSocialMediaMessageFilesForSendDto> {
    return this.socialNetworkMessageFilesGetSocialMediaMessageFilesForSend$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfListOfSocialMediaMessageFilesForSendDto>): CustomResultOfListOfSocialMediaMessageFilesForSendDto => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesDownloadSocialMediaMessageFileById()` */
  static readonly SocialNetworkMessageFilesDownloadSocialMediaMessageFileByIdPath = '/SocialNetworkMessageFiles/DownloadSocialMediaMessageFileById';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesDownloadSocialMediaMessageFileById()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesDownloadSocialMediaMessageFileById$Response(params?: SocialNetworkMessageFilesDownloadSocialMediaMessageFileById$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfString>> {
    return socialNetworkMessageFilesDownloadSocialMediaMessageFileById(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesDownloadSocialMediaMessageFileById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesDownloadSocialMediaMessageFileById(params?: SocialNetworkMessageFilesDownloadSocialMediaMessageFileById$Params, context?: HttpContext): Observable<CustomResultOfString> {
    return this.socialNetworkMessageFilesDownloadSocialMediaMessageFileById$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfString>): CustomResultOfString => r.body)
    );
  }

  /** Path part for operation `socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray()` */
  static readonly SocialNetworkMessageFilesDownloadSocialMediaFileAsByteArrayPath = '/SocialNetworkMessageFiles/DownloadSocialMediaFileAsByteArray';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray$Response(params?: SocialNetworkMessageFilesDownloadSocialMediaFileAsByteArray$Params, context?: HttpContext): Observable<StrictHttpResponse<CustomResultOfByteOf>> {
    return socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray(params?: SocialNetworkMessageFilesDownloadSocialMediaFileAsByteArray$Params, context?: HttpContext): Observable<CustomResultOfByteOf> {
    return this.socialNetworkMessageFilesDownloadSocialMediaFileAsByteArray$Response(params, context).pipe(
      map((r: StrictHttpResponse<CustomResultOfByteOf>): CustomResultOfByteOf => r.body)
    );
  }

}
